/* eslint-disable */
import styles from './style.module.scss';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';
import { t } from '@web-solutions/module-localization';
import { useNav } from 'src/onboarding/hooks/nav';
import Button from 'src/onboarding/components/ui/button/Button';
import { Title } from 'src/onboarding/components/typography/Title/Title';
import { Text } from 'src/onboarding/components/typography/Text/Text';
import { useStore } from 'src/onboarding/store/store';
import { getAgeGroup } from 'src/onboarding/helpers/getAgeGroup';
import { useRemoteConfig } from 'core/hooks/use-remote-config';
import getLocale from 'src/localization/get-locale';

function Page() {
  const { onNext, onPrev, currentIndex } = useNav();
  const gender = useStore((state) => state.gender);
  const born = useStore((state) => state.born);
  const goalRightNow = useStore((state) => state.goalRightNow);
  const { showImage } = useRemoteConfig();

  const getLocalizedGoal = (): string => {
    const normalizedGoalKey = goalRightNow?.toLowerCase();

    switch (normalizedGoalKey) {
      case 'lose weight':
        return t('onboarding.thisWillWork.loseWeight');
      case 'get fit body':
        return t('onboarding.thisWillWork.getFitBody');
      case 'eat healthier':
        return t('onboarding.thisWillWork.eatHealthier');
      default:
        return t('onboarding.thisWillWork.loseWeight');
    }
  };

  const genderAge = (
    <span className={styles.highlight}>
      {t('onboarding.thisWillWork.genderAge', {
        gender:
          gender === 'Female'
            ? t('onboarding.thisWillWork.women')
            : t('onboarding.thisWillWork.men'),
        age: getAgeGroup(born),
        // French cannot build "30s" from a suffix; give it a numeric range instead.
        ageFrom: born >= 20 ? Math.floor(born / 10) * 10 : 18,
        ageTo: born >= 20 ? Math.floor(born / 10) * 10 + 9 : 19,
      })}
    </span>
  );

  const goal = (
    <>
      <br />
      <span className={styles.highlight}>{getLocalizedGoal()}.</span>
    </>
  );

  return (
    <div className={styles.page}>
      {currentIndex !== 0 && (
        <div className={styles.back} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={styles.wrapperInfo}>
        {/* `lang` lets the browser hyphenate "fonctionner" / "funktionieren"
            properly instead of letting the word run into the photo. */}
        <Title className={styles.title} lang={getLocale()}>
          {t('onboarding.thisWillWork.title')}
        </Title>
        <Text semibold className={styles.description}>
          {t('onboarding.thisWillWork.subTitle1_start')} {genderAge}{' '}
          {t('onboarding.thisWillWork.subTitle1_end')} {goal}
        </Text>
        <Text semibold className={styles.description}>
          <span className={styles.highlight}>{t('onboarding.thisWillWork.subTitle2_first')}</span>{' '}
          {t('onboarding.thisWillWork.subTitle2_rest')}
        </Text>
      </div>
      {showImage && <div className={gender === 'Male' ? styles.imageMen : styles.image}></div>}
      <div className={styles.continue}>
        <div className={styles.blur}></div>
        <Button onClick={onNext} title={t('onboarding.thisWillWork.continue')} />
      </div>
    </div>
  );
}

export default Page;
